/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { useEffect, useState } from 'react';
import { Select, SelectItem } from '@carbon/react';
import { uniqueId } from 'lodash';

const TestToolSecurityFlows = ({ flows, currentFlow, onChange }) => {
  const [flow, setFlow] = useState(null);
  const [id, setId] = useState('');
  useEffect(() => {
    let newFlow = flow;
    if (flow === null) {
      newFlow = Object.keys(flows)[0];
    }
    if (currentFlow && newFlow !== currentFlow) {
      newFlow = currentFlow;
    }
    if (newFlow !== flow) {
      // Only update if there's an actual change
      setFlow(newFlow);
    }
  }, [currentFlow, flows, flow]);

  useEffect(() => {
    const id = uniqueId('security-flow-select');
    setId(id);
  }, []);

  const handleFlowChange = (event) => {
    const selectedFlow = event.target.value;
    setFlow(selectedFlow); // Update state with selected value
    if (onChange && typeof onChange === 'function') {
      onChange(selectedFlow);
    }
  };
  return (
    <div className="securityFlowChooser">
      {flow && (
        <Select value={flow} onChange={handleFlowChange} id={id} hideLabel>
          {Object.keys(flows).map((currentflow) => {
            return <SelectItem key={currentflow} value={currentflow} text={currentflow} />;
          })}
        </Select>
      )}
    </div>
  );
};

export default TestToolSecurityFlows;
